
import { Component, Prop, Vue } from 'vue-property-decorator';
import { I18n } from '../../lib/interfaces/I18n';
import deDE from '../../lib/presets/resources/de-DE';
import { container } from '../../lib/container';
import { SearchStorage } from '../../lib/core/storage/SearchStorage';
import { ContainerTypes } from '../../lib/core/types/ContainerTypes';

const storage = container.get<SearchStorage>(ContainerTypes.SearchStorage);

@Component
export default class BranchFilter extends Vue {
	@Prop({ required: true })
	label!: string;
	@Prop({ required: true })
	branches!: string[];

	isActive = false;

	$refs!: {
		checkbox: HTMLInputElement;
		checkmark: HTMLElement;
	};

	i18n: I18n = deDE;

	getCheckMark() {
		return this.isActive ? 'check_box' : 'check_box_outline_blank';
	}

	changeFilter(event: Event) {
		const element = event.target as HTMLInputElement;
		this.isActive = element.checked;
		this.$emit(element.checked ? 'check' : 'uncheck', {
			label: this.label,
			branches: this.label
		});
	}

	mounted() {
		this.isActive = storage.filters.indexOf(this.label) > -1;
	}
}
